import { render, staticRenderFns } from "./MetricWidget.vue?vue&type=template&id=f888ffc0&scoped=true"
import script from "./MetricWidget.vue?vue&type=script&lang=ts"
export * from "./MetricWidget.vue?vue&type=script&lang=ts"
import style0 from "./MetricWidget.vue?vue&type=style&index=0&id=f888ffc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f888ffc0",
  null
  
)

export default component.exports